import angular from 'angular';
import { merge } from 'lodash';

import { PreferenceResource } from '@mode/legacy/data-access-model-js';
import { AppState, TransientState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '../actions';
import { ClientActionType } from '../actions/client.actions';
import { EditorActionType } from '../actions/editor-actions';
import { initialTransientEditorState, TransientEditorReducer } from './transient/editor.reducers';
import { initialTransientExplorerState, TransientExplorerReducer } from './transient/explorer.reducers';
import { initialTransientReportState, TransientReportReducer } from './transient/report.reducers';
import { initialWindowState, TransientWindowReducer } from './transient/window.reducers';

export const initialTransientState: TransientState = {
  report: initialTransientReportState,
  editor: initialTransientEditorState,
  explorer: initialTransientExplorerState,
  accountPreference: null,
  window: initialWindowState,
};

function accountPreferenceReducer(
  state: Readonly<PreferenceResource> = undefined,
  action: Actions
): TransientState['accountPreference'] {
  switch (action.type) {
    case ClientActionType.LoadAccountPreferenceSuccess:
      return action.preferenceResource;
    case ClientActionType.UpdatePreference:
      return Object.assign(angular.copy(state), action.params);
    case EditorActionType.ToggleNotebookSidebar:
      return merge(angular.copy(state), {
        notebook_sidebar: {
          open: !state.notebook_sidebar.open,
          items: {
            intro: false,
            shortcuts: true,
          },
        },
      });
  }

  return state;
}

export const TransientReducer: ReducerTree<AppState, TransientState, Actions> = {
  report: TransientReportReducer,
  editor: TransientEditorReducer,
  explorer: TransientExplorerReducer,
  accountPreference: accountPreferenceReducer,
  window: TransientWindowReducer,
};
